import EntityModel from "../../entity/_model/EntityModel";
import {EntityType} from "../../entity/_model/entity.constants";
import type {IContentAppDto} from "./content-app.dto";

export default class ContentAppModel extends EntityModel implements IContentAppDto {
    public entityType: EntityType = EntityType.CONTENT_APP;

    public resourceIdentifier = "";
    public dataProviderURI?: string;
}
